module.exports = __webpack_public_path__ + "static/img/29.8ebded06.gif";